import { GraphicSymbolSearchHit } from '@features/search/graphic-symbol-search-hit';
import { ImageSearchHit } from '@features/search/image-search-hit';
import { PublicationSearchHit } from '@features/search/publication-search-hit';
import { SearchHit } from '@features/search/search-hit';
import { AssetType } from '@imcc/transport';
import { Type } from 'class-transformer';
import { SearchResultInfo } from './search-result-info';

export class SearchResult {
  @Type(() => SearchResultInfo)
  info: SearchResultInfo = new SearchResultInfo();

  @Type(() => Object, {
    keepDiscriminatorProperty: true,
    discriminator: {
      property: 'assetType',
      subTypes: [
        { value: ImageSearchHit, name: AssetType.Image },
        { value: PublicationSearchHit, name: AssetType.Publication },
        { value: GraphicSymbolSearchHit, name: AssetType.GraphicSymbol },
      ],
    },
  })
  hits: SearchHit[] = [];
}
